import { useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../shared/FormStyles';
import { Tab } from './Tab.jsx';
import { PRIZE_STATUS, CANCEL_STATUSES } from '../utils/constants';
import ModalConfirmation from '../../../shared/ModalConfirmation';
import Modal from '../../../shared/Modal';
import usePrizeForm from './usePrizeForm';

const TABS = [
  { title: 'Setup', statuses: ['set_up'] },
  { title: 'Live', statuses: ['live'] },
  { title: 'Winners', statuses: ['picked_winners', 'pick_winners'] },
];
function HeaderActions({ raffle }) {
  const { t } = useTranslation('prizes');
  const { onCancel, onStartNew } = usePrizeForm({
    prizeValues: raffle,
  });

  const confirmCancel = useCallback(() => {
    Modal({
      component: (
        <ModalConfirmation
          onSave={onCancel}
          header={t('live.cancelRaffleHeader')}
          body={t('live.cancelRaffleBody')}
        />
      ),
    });
  }, [onCancel, t]);

  const confirmStartNew = useCallback(() => {
    Modal({
      component: (
        <ModalConfirmation
          onSave={onStartNew}
          header={t('pickWinners.startNewRaffleHeader')}
          body={t('pickWinners.startNewRaffleBody')}
        />
      ),
    });
  }, [onStartNew, t]);

  return (
    <ButtonsContainer>
      <li className="mr-1">
        <Button
          className="mb-0"
          disabled={!CANCEL_STATUSES.includes(raffle.status)}
          onClick={confirmCancel}
          variant="tertiary"
        >
          {t('nav.cancel')}
        </Button>
      </li>
      <li>
        <Button
          className="mb-0"
          disabled={raffle.status !== PRIZE_STATUS.picked_winners}
          onClick={confirmStartNew}
          variant="containedBlue"
        >
          {t('nav.newPrize')}
        </Button>
      </li>
    </ButtonsContainer>
  );
}

const Navbar = ({ raffle }) => {
  return (
    <NavContainer>
      <TabList>
        {TABS.map(tab => (
          <Tab
            key={tab.title}
            title={tab.title}
            statuses={tab.statuses}
            activeStatus={raffle.status}
          />
        ))}
      </TabList>
      <HeaderActions raffle={raffle} />
    </NavContainer>
  );
};

export default Navbar;

const NavContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  margin: 0 0 24px;
`;

const ButtonsContainer = styled.ul`
  display: flex;
`;

const TabList = styled.ul`
  display: flex;
`;
